import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { forgotPassword } from '../../api';

function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await forgotPassword(email.toLowerCase().trim());
      setSent(true);
    } catch (err: any) {
      setError(err?.response?.data?.message || err?.message || 'Something went wrong. Please try again.');
    } finally {
      setBusy(false);
    }
  }

  if (sent) {
    return (
      <div className="authShell">
        <div className="authCard">
          <div className="authKicker">Password reset</div>
          <h1>Check your email</h1>
          <p>
            If <strong>{email}</strong> is registered, you will receive a reset link shortly. It expires in 1 hour.
          </p>
          <button
            type="button"
            className="primaryButton authSubmit"
            onClick={() => navigate('/login')}
          >
            Back to sign in
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="authShell">
      <form className="authCard" onSubmit={handleSubmit}>
        <div className="authKicker">Cindro Admin</div>
        <h1>Forgot password</h1>
        <p>Enter your email and we will send you a link to reset your password.</p>

        <label className="authField">
          <span>Email</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="sarah@acme.com"
            required
            autoFocus
          />
        </label>

        {error ? <div className="authError">{error}</div> : null}

        <button type="submit" className="primaryButton authSubmit" disabled={busy || !email.trim()}>
          {busy ? 'Sending…' : 'Send reset link'}
        </button>

        <button
          type="button"
          className="authLink"
          style={{ marginTop: '0.5rem', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--color-text-muted, #6b7280)', fontSize: '0.875rem' }}
          onClick={() => navigate('/login')}
        >
          Back to sign in
        </button>
      </form>
    </div>
  );
}

export { ForgotPasswordPage };
